import { Text } from "@/components/ui/baseUi/text"
import type { MediaItemFormType } from "@/modules/common/media/mediaFormTypes"
import { cn } from "@/modules/lib/utils"
import { type MediaBlockItemFormikType } from "@/modules/sessions/sessionForm/blocks/mediaBlock/mediaBlockFormikTypes"
import { word } from "@modules/core/utils/i18n"
import { VimeoPlayer } from "@modules/utils/components/vimeoVideo"

type MediaExistingBlockVimeoProps = {
  id: string
  media: MediaBlockItemFormikType | MediaItemFormType
  className?: string
} & React.ComponentProps<"div">

export function MediaExistingBlockVimeo({ media, id, className, ...props }: MediaExistingBlockVimeoProps) {
  return (
    <div className={cn("flex flex-row items-center gap-3", className)} {...props}>
      {media.url ? (
        <VimeoPlayer
          id={id}
          link={media.url}
          height={102}
          width={179}
          className="max-w-max overflow-hidden rounded-4xl"
        />
      ) : (
        <Text fontStyle="BM" className="wrap-break-word">
          {word("sessionForm.blocks.add_media.missing_error")}
        </Text>
      )}
      <Text fontStyle="BM" className="wrap-break-word">
        {word("sessionForm.blocks.add_media.vimeo_link.label")}
      </Text>
    </div>
  )
}
